import React, { useCallback } from 'react';

import Box from '@mui/material/Box';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemSecondaryAction from '@mui/material/ListItemSecondaryAction';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';

import ReorderIcon from '@mui/icons-material/Reorder';
import DeleteIcon from '@mui/icons-material/Delete';

import { PracticeExercise } from '../../types';

export interface SelectedExerciseListItemProps {
  exercise: PracticeExercise;
  onRemoveExercise?: (exercise: PracticeExercise) => void;
}

const SelectedExerciseListItem = (props: SelectedExerciseListItemProps) => {
  const { exercise, onRemoveExercise } = props;

  const handleRemoveExercise = useCallback(() => {
    onRemoveExercise?.(exercise);
  }, [exercise, onRemoveExercise]);

  return (
    <Box>
      <ListItem
        sx={{
          bgcolor: 'white',
        }}
      >
        <ListItemIcon>
          <ReorderIcon />
        </ListItemIcon>
        <ListItemText primary={exercise.code} secondary={exercise.subjectPath} />
        {onRemoveExercise && (
          <ListItemSecondaryAction>
            <IconButton onClick={handleRemoveExercise} size="large">
              <DeleteIcon />
            </IconButton>
          </ListItemSecondaryAction>
        )}
      </ListItem>
      <Divider />
    </Box>
  );
};

export default SelectedExerciseListItem;
